import { render, staticRenderFns } from "./panel-3.vue?vue&type=template&id=28b2534c&scoped=true"
import script from "./panel-3.vue?vue&type=script&lang=js"
export * from "./panel-3.vue?vue&type=script&lang=js"
import style0 from "./panel-3.vue?vue&type=style&index=0&id=28b2534c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b2534c",
  null
  
)

export default component.exports